import { FC, useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import FooterText from "../../components/footerText";
import AuthSubHeader from "src/components/authSubHeader";

import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { LoaderContext } from "src/context/loaderContext";
import { PrecertResponse } from  './types';



const Review: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const navigate = useNavigate();
  const { caseId, precertsId } = useParams();




  const {loading:isApproveLoading ,  error: approveReviewPrecertError, data: approveReviewPrecertData, mutate: approveReviewPrecertReview } =
    useFetch<PrecertResponse>(APIEndpoints.REVIEW_PRECERT_APPROVE, {}, { caseId, precertId: precertsId });

  useEffect(() => {
    if (approveReviewPrecertData || approveReviewPrecertError) {
      hideLoader()
      if(approveReviewPrecertData) {
        const { message } = approveReviewPrecertData;
        showToast([message], ToastTypes.SUCCESS);
        navigate("/cases");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [approveReviewPrecertData, approveReviewPrecertError]);

  const approvePrecertReview = () => {
    // eslint-disable-next-line no-restricted-globals
    const res = confirm("Are you sure wish to send this precert to the insurance company? This cannot be undone!");
    if (res) {
      setLoader()
      approveReviewPrecertReview({},{caseId, precertId: precertsId})
    }
  }


  
  
  
  const { loading: isDenyLoading, error: denyReviewPrecertError, data: denyReviewPrecertData, mutate: denyReviewPrecertReview } =
    useFetch<PrecertResponse>(APIEndpoints.REVIEW_PRECERT_DENY, {}, { caseId, precertId: precertsId });

  useEffect(() => {
    if (denyReviewPrecertData || denyReviewPrecertError) {
      hideLoader()
      if(denyReviewPrecertData) {
        const { message } = denyReviewPrecertData;
        showToast([message], ToastTypes.SUCCESS);
        navigate("/cases");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [denyReviewPrecertData, denyReviewPrecertError]);

  const denyPrecertReview = () => {
    // eslint-disable-next-line no-restricted-globals
    const res = confirm("Are you sure you wish to deny this precert request?");
    if (res) {
      setLoader()
      denyReviewPrecertReview({},{caseId, precertId: precertsId})
    }
  }





  return (
    <div className="container-fluid cases-page bg-primary-sky overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
      <div className="container">
        <AuthSubHeader />

        <div className="card mt-4">
          <div className="card-header">
            <h4 className="mb-0">Precert Confirmation</h4>
          </div>
          <div className="card-body"></div>
        </div>

        <div className="mt-3 text-end">
          <button
            className="btn btn-green background-color-2 mx-3 rounded-0" type="button" name="cancel"
            onClick={() => approvePrecertReview()}
            disabled={isApproveLoading}
          >
            Approve
          </button>

          <button
            className="btn btn-danger rounded-0" type="button"
            onClick={denyPrecertReview}
            disabled={isDenyLoading}
          >
            Deny
          </button>
        </div>
      </div>
      <div className="mt-3"><FooterText /></div>
    </div>
  );
};

export default Review;
